import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=5b78dcb1&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=5b78dcb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78dcb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5b78dcb1', component.options)
    } else {
      api.reload('5b78dcb1', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=5b78dcb1&scoped=true&", function () {
      api.rerender('5b78dcb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analysis/dashboard.vue"
export default component.exports